import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsAr from "../locales/ar/translationsAr.json";
import translationsEn from "../locales/en/translationsEn.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationsEn },
      ar: { translation: translationsAr }
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
